// hooks/useDomainSuggestions.js
import * as LucideIcons from 'lucide-react';
import { useEffect, useState } from 'react';
import domainsData from '../../../../../data-skills/skills/domains.json';

// Fonction utilitaire pour récupérer l'icône React depuis Lucide
export const getReactIcon = (iconName, props = {}) => {
    if (!iconName) return null;

    const IconComponent = LucideIcons[iconName];
    if (!IconComponent) {
        return LucideIcons.Circle; // Icône de fallback
    }

    return IconComponent;
};

export const useDomainSuggestions = () => {
    const [domainSuggestions, setDomainSuggestions] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        try {
            // Extraire les noms des domaines depuis le JSON importé
            const suggestions = domainsData.domains.map(domain => domain.nom);
            setDomainSuggestions(suggestions);
            setLoading(false);
        } catch (err) {
            setError(err.message);
            setLoading(false);
        }
    }, []);

    return { domainSuggestions, loading, error };
};

// Service pour récupérer les domaines complets
export const getDomainsData = () => {
    return domainsData.domains;
};

// Service pour récupérer un domaine par ID
export const getDomainById = (id) => {
    return domainsData.domains.find(domain => domain.id === id);
};

// Service pour récupérer un domaine par nom (pour les domaines personnalisés)
export const getDomainByName = (name) => {
    // Nettoyer le nom pour la comparaison
    const cleanName = name.toLowerCase().trim();
    return domainsData.domains.find(domain => {
        const domainName = domain.nom.toLowerCase().trim();

        // Correspondance exacte d'abord
        if (domainName === cleanName) return true;

        // Correspondance sans accents et caractères spéciaux
        const normalizedDomainName = domainName
            .normalize("NFD").replace(/[\u0300-\u036f]/g, "") // Supprimer les accents
            .replace(/[&\s-]+/g, ""); // Supprimer espaces, tirets et &

        const normalizedCleanName = cleanName
            .normalize("NFD").replace(/[\u0300-\u036f]/g, "") // Supprimer les accents
            .replace(/[&\s-]+/g, ""); // Supprimer espaces, tirets et &

        return normalizedDomainName === normalizedCleanName ||
            normalizedDomainName.includes(normalizedCleanName) ||
            normalizedCleanName.includes(normalizedDomainName);
    });
};

// Service combiné pour récupérer un domaine par ID ou nom
export const getDomainInfo = (identifier) => {
    // D'abord essayer par ID
    let domain = getDomainById(identifier);

    // Si pas trouvé, essayer par nom
    if (!domain) {
        domain = getDomainByName(identifier);
    }

    return domain;
};

// Service pour récupérer l'icône React d'un domaine
export const getDomainIcon = (identifier, props = { className: "w-4 h-4" }) => {
    const domain = getDomainInfo(identifier);
    if (!domain || !domain.icon) return null;

    const IconComponent = getReactIcon(domain.icon);
    if (!IconComponent) return null;

    return IconComponent;
};